import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({}, { border })=>({
        root: {
            border: border
        }
    }));
export { useStyles };
